module.exports = __webpack_public_path__ + "img/ic-mobile-app.b54ea1bc.svg";